import {array, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringOptionalNullable} from '@shared/utils';
import {RelatedEntityType} from '../types';

export const transactionV8nSchema = object().shape({
  id: string().required(),
  user_id: string().required(),
  real_amount: number().integer().required(),
  promo_amount: number().integer().required(),
  coins_amount: number().integer().optional(),
  real_amount_local: number().integer().nullable().optional(),
  promo_amount_local: number().integer().nullable().optional(),
  currency: string().nullable().optional(),
  method: object()
    .shape({
      name: string().required(),
      currency: string().required(),
      provider: string().required(),
      country: string().nullable().optional(),
    })
    .default(undefined)
    .nullable()
    .optional(),
  created_at: string().required(),
  type: string().oneOf(['money', 'coin']).optional(),
  related_entity: string().oneOf(Object.values(RelatedEntityType)).nullable(),
  related_entity_id: stringOptionalNullable,
  label: stringOptionalNullable,
  payment_type: string().oneOf(['deposit', 'withdrawals']).nullable(),
  txn_type: stringOptionalNullable,
  event_id: stringOptionalNullable,
  event_uuid: stringOptionalNullable,
  meta: array().of(string().required()),
});

export const v8nSchemaOfGetTransactionHistoryResponse =
  paginationV8nSchema.shape({
    array: array().of(transactionV8nSchema),
  });

const adminMethodV8nSchema = object().shape({
  id: string().required(),
  name: string().required(),
  currency: string().required(),
  provider: string().required(),
  token_code: string().required(),
});

const paymentDetailsCommonShape = {
  user_id: string().required(),
  status: string().required(),
  amount: number().integer().required(),
  fee: number().integer().required(),
  fee_compensation: number().integer().required(),
  fiat_amount: number().integer().nullable().optional(),
  rate_snapshot: stringOptionalNullable,
  tracker_id: stringOptionalNullable,
  created_at: stringOptionalNullable,
  completed_at: stringOptionalNullable,
  failure_code: stringOptionalNullable,
  failure_detail: stringOptionalNullable,
  method: adminMethodV8nSchema.nullable().optional(),
};

export const depositDetailsV8nSchema = object().shape({
  ...paymentDetailsCommonShape,
  deposit_id: string().required(),
  amount_fiat_received: number().integer().nullable().optional(),
  redirect_url: stringOptionalNullable,
  promo_code: stringOptionalNullable,
  promo_percent: number().integer().nullable().optional(),
  promo_max_bonus: number().integer().nullable().optional(),
});

export const payoutDetailsV8nSchema = object().shape({
  ...paymentDetailsCommonShape,
  payout_id: string().required(),
  amount_fiat_sent: number().integer().nullable().optional(),
  receiver: stringOptionalNullable,
});

export const providerRequestLogV8nSchema = object().shape({
  id: string().required(),
  provider: string().required(),
  direction: string().required(),
  entity_type: string().required(),
  endpoint: string().required(),
  method: string().required(),
  url: string().required(),
  status_code: number().integer().nullable().optional(),
  created_at: string().required(),
  request_body: object().nullable().optional(),
  response_body: object().nullable().optional(),
});

export const v8nSchemaOfProviderRequestLogsResponse = object().shape({
  array: array().of(providerRequestLogV8nSchema).required(),
});
